import React from 'react'

// Document glyph from the DS (Figma 709:12579). Sizes with 1em, inherits currentColor.
const PATH_D = 'M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 '
  + '4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 '
  + '19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z'

const FileIcon = () => (
  <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH_D} fill="currentColor" />
  </svg>
)

export default FileIcon
